import React, {PureComponent} from 'react'
import {injectIntl, WrappedComponentProps} from 'react-intl';
import {Button} from "reactstrap";
import {AdobeAnalyticsContext} from "../context/AdobeAnalyticsContext";
import {scrollToElement} from "../utils/browser";

interface Props {
    onChange: Function;
    value: string;
}

class FilterGameName extends PureComponent<Props & WrappedComponentProps> {
    static contextType = AdobeAnalyticsContext;
    context!: React.ContextType<typeof AdobeAnalyticsContext>;

    private input = React.createRef<HTMLInputElement>();

    handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onChange(e.currentTarget.value);
    };

    render() {
        return (
            <>
                <div className="searchbox" id="searchbox" onClick={() => this.input.current && this.input.current.focus()}>
                    <i className="material-icons">search</i>
                    <div className="input">
                        <input
                            type="text"
                            id="gameName"
                            placeholder={this.props.intl.formatMessage({id: "action.search_for_game"})}
                            onChange={this.handleChange}
                            onFocus={this.trackSearchEvent}
                            value={this.props.value}
                            ref={this.input}
                            autoComplete="off"
                        />
                    </div>
                    {this.props.value && <Button close onClick={this.clearSearchField}/>}
                </div>

                <div className="floating-search" onClick={this.goToSearch}>
                    <i className="material-icons floating-search-icon">search</i>
                </div>
            </>
        )
    }

    clearSearchField = (event: React.MouseEvent) => {
        event.stopPropagation();
        this.props.onChange('');
    };

    trackSearchEvent = () => {
        this.context.track("clickevent", {location: "search bar", category: "interaction", action: "search field"});
    };

    goToSearch = () => {
        scrollToElement("searchbox");
        this.input.current && this.input.current.focus();
    };
}

export default injectIntl(FilterGameName);